import { useRouter } from "next/router";

import { useEffect, useMemo, useState } from "react";

import { findIndex } from "lodash";
import { twMerge } from "tailwind-merge";

import Swipper from "components/Swipper";
import useAuthentication from "hooks/useAuthentication";

import { AVAILABLE_TABS } from "../ToolsPageTabs";

export default function ToolsPageLayoutMobile({ children }: any) {
  const { authenticated } = useAuthentication();
  const router = useRouter();

  const tab = router.query.tab as
    | "markets"
    | "event-driven"
    | "screeners"
    | "insight-providers";

  const [index, setIndex] = useState(0);

  const tabs: any = useMemo(() => {
    if (authenticated) {
      return AVAILABLE_TABS;
    }

    return AVAILABLE_TABS;
  }, [authenticated]);

  useEffect(() => {
    const currentIndex = findIndex(tabs, (item: any) => {
      return item.id === tab;
    });

    setIndex(currentIndex);
  }, [tab, tabs]);

  return (
    <div className="mt-[54px]">
      <Swipper
        index={index}
        maxIndex={tabs.length}
        onIndexChange={(index) => {
          router.push(tabs[index].href);
        }}
      >
        <div
          className={twMerge("p-[15px]", "min-h-[calc(100vh-150px)]", "w-full")}
        >
          {children}
        </div>
      </Swipper>
    </div>
  );
}
